module.exports = __webpack_public_path__ + "static/media/guide_Page_04.d51b1ed1.png";